import { Box, Button, Flex, HStack, Heading, Image, SimpleGrid, Skeleton, Spacer, Text, position } from "@chakra-ui/react";
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import { useEffect, useState } from "react";

// Components
import FormularioDown from "../../Components/Formulario/FormularioDown";
import SlideModal from "../../Components/Slide/SlideModal";
import { getData } from "../../Services/api";

// Icons
import { Icon5G, IconArrowRight, IconBci, IconEntelVisa, IconEquipo, IconOferta, IconSantander } from "../../Assets/GENERALES/Icons";
import { IconBancoChile, IconDelivery, IconEntelExpress, IconMastercard, IconPagoCuotas, IconVisa } from "../../Assets/equipos/Icons";
import harman from "../../Assets/EQUIPOS/ICONS/Harman_Kardon.svg";
import motorola from "../../Assets/EQUIPOS/ICONS/Motorola.svg";
import xiaomi from "../../Assets/EQUIPOS/ICONS/Xiaomi.svg";
import apple from "../../Assets/EQUIPOS/ICONS/Apple.svg";
import samsung from "../../Assets/EQUIPOS/ICONS/g10.svg";
import honor from "../../Assets/EQUIPOS/ICONS/Honor.svg";
import sony from "../../Assets/EQUIPOS/ICONS/Logo.svg";

// Images
import EquiposDownMovil from '../../Assets/equipos/Banner_Inferior_Mobile.webp';
import ImgBannerHogarDesktop from '../../Assets/equipos/Imagen-banner-Desktop.webp';
import ImgBannerHogarMobile from '../../Assets/equipos/Imagen-banner-Movil.webp';
import EquiposDown from '../../Assets/equipos/equipos_down.webp';
import Movil from '../../Assets/EQUIPOS/movil.webp';

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import './style.css';

const Equipos = () => {

    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [positionEquipo, setPositionEquipo] = useState('');
    const [equipoSelected, setEquipoSelected] = useState('');
    const [targetEquipos, setTargetEquipos] = useState([]);
    const [isBanner, setIsBanner] = useState(false);
    const [id, setId] = useState('');

    useEffect(() => {
        const extractEquipos = async() => {
            const consultData = await getData('view');
            if (consultData?.data?.OK == true) {
                setTargetEquipos(consultData?.data?.DATA);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: `Ocurrio un error!`
                });
            }
        };

        extractEquipos();
    }, []);
    
    const formatNumber = (number) => {
        const parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    };

    const openSlide = (view='', descuento='', product='', position='', price='', subprice='') => {
        if (view !== 'Banner') {
            window.dataLayer.push({
                'event': 'GARDevent',
                'eventCategory':'entel ofertas - terminales',
                'eventAction':'click to action',
                'eventLabel':'lo quiero',
                'origen':'entel',
                'segmento':'tm-equ',
                'mercado':'pe',
                'product':product,
                'product_price':price,
                'product_subprice':subprice,
                'type_offer':descuento.replace('%', 'porciento dcto'),
                'position':position,
            });

            setId(`equipo_promo_${position}`);
            setEquipoSelected(`Formulario equipo ${position}`);
            setPositionEquipo(position);
            setIsBanner(false);
        } else {
            window.dataLayer.push({
                event: "GARDevent",
                eventCategory: "entel ofertas - banner principal",
                eventAction: "click to action",
                eventLabel: "lo quiero",
                origen: "entel",
                segmento: "tm-equ",
                mercado: "pe",
                description: "renueva tu equipo",
                variant: "formulario banner principal equipos"
            });
            
            setEquipoSelected('Formulario Banner');
            setId(`form_banner_equipos`);
            setIsBanner(true);
        };

        setOpenSlideModal(true);
    };

    return (
        <>
            {/* Banner */}
            <Box 
                position="relative" 
                w="100%" 
                h={['232px','232px','280px','280px','280px']} 
                onClick={() => openSlide('Banner')}
            >
                {/* Imagen principal */}
                <Image
                    src={ImgBannerHogarDesktop}
                    srcSet={`${ImgBannerHogarMobile} 768w, ${ImgBannerHogarDesktop} 1024w`}
                    sizes="(max-width: 768px) 100px, 1024px"
                    alt="Banner equipos hogar"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                />

                {/* Contenido encima */}
                <Flex 
                    position="absolute" 
                    top="0" 
                    left="0"
                    right="0"
                    w="90%" 
                    h="100%" 
                    flexDirection="row" 
                    px="5" 
                    mx="auto"
                >
                    <Box my="auto">
                        <HStack mt={[4,4,0]}>
                            <IconEquipo color="black" />
                            <Text className="Title" color="black" fontSize="md">
                            Equipos
                            </Text>
                        </HStack>

                        <Heading 
                            fontWeight="400" 
                            color="black" 
                            mt="5" 
                            fontSize={['32px','32px','42px']} 
                            className="General" 
                            lineHeight="1"
                        >
                            ¡Renuévate con hasta 40% de Dcto!
                        </Heading>

                        <Text 
                            fontWeight="400" 
                            as="h1" 
                            fontSize={['12px','12px','16px']} 
                            mt="4" 
                            className="General" 
                            lineHeight="1" 
                            color="black"
                        >
                            Porta o contrata una línea con equipo.
                        </Text>

                        <Button 
                            onClick={() => openSlide('Banner')} 
                            borderRadius="30" 
                            size={['sm','sm','md']} 
                            mt={6} 
                            w="50%" 
                            className="General" 
                            border="2px solid #002FFD" 
                            bg="#002FFD" 
                            color="white" 
                            _hover={{ bg: 'white', color: '#002FFD' }}
                        >
                            Lo quiero
                        </Button>
                    </Box>
                    <Spacer />
                </Flex>
            </Box>


            {/* Equipos */}
            <Box mx="auto" w={['90%','90%','90%','90%','90%']} mt={['10','10','5','5','5']}>
                <Splide
                    hasTrack={false}
                    options={{
                        type: 'slide',
                        perMove: 1,
                        pagination: true,
                        autoplay: false,
                        autoWidth: true,
                        gap: '30px',
                    }}
                >
                    <SplideTrack>
                        {
                            targetEquipos.length > 0
                            ? targetEquipos.map((equipos, i) => (
                                equipos.equipo_principal === 0
                                    ? <SplideSlide key={equipos.equipo_id}>
                                        <Flex flexDirection={['row', 'row','row','column','column']} h={['278px','278px','278px','100%','100%']} w={['344px','344px','344px','307px','307px']} border='1px solid #E9E9E9' borderRadius='12px' _hover={{border:'1px solid #002EFF'}} >
                                            <Flex bg='#F7F7F7' w={['126px','126px','126px','100%','100%']} p='16px' justifyContent='center' alignItems='center' borderLeftRadius={['12px','12px','12px','0px','0px']} borderTopRadius={['0px','0px','0px','12px','12px']} position='relative' borderBottom='1px solid #D7D7D7'>
                                                <Box position='absolute' top='2' right='2' left={[2,2,2,'auto','auto']} display={['none','none','none','block','block']}>
                                                    <Icon5G size='48' />
                                                </Box>
                                                <Box position='absolute' top='2' right='2' left={[2,2,2,'auto','auto']} display={['block','block','block','none','none']}>
                                                    <Icon5G size='32' />
                                                </Box>
                                                <Flex w={['100px','100px','100px','272px','272px']} h={['150px','150px','150px','226px','226px']} justifyContent='center' alignItems='center'  borderTopLeftRadius='12px'>
                                                    <Image src={`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${equipos.equipo_imagen}`} w='auto' h='auto' />
                                                </Flex>
                                            </Flex>
                                            <Box px='3' py='4'>
                                                <Text className="Title" fontSize='16px'>
                                                    {equipos.equipo_nombre}
                                                </Text>
                                                <Text className="Subtitle" fontSize={['16px','16px','16px','18px','18px']} h='60px' noOfLines='2'>  
                                                    {equipos.equipo_referencia}
                                                </Text>
                                                
                                                <HStack mt='3' spacing='0' >
                                                    <Text border='1px solid #42E8B4' color='black' bg='#42E8B4' px='2' className="Title" h='auto' lineHeight='1.1' borderRadius='4px' fontSize='sm'>
                                                        {equipos.equipo_descuento}% dcto.
                                                    </Text>
                                                </HStack>
                                                
                                                <HStack spacing='1' mt='1'>
                                                    <Text color='#66686C' className="Subtitle" fontSize={['12px','12px','12px','14px','14px']} my='1'> 
                                                        Precio normal:
                                                    </Text>
                                                    <Text className='Subtitle' as='s'>${formatNumber(equipos.equipo_precio_normal)}</Text>
                                                </HStack>
                                                <Text className="General" color='#002EFF'>Precio oferta:</Text>
                                                <Flex alignItems='end' mt='2'>
                                                    <Heading size='md' className="Title" fontSize={['14px','14px','14px','18px','18px']} color='#002EFF'>
                                                        $
                                                    </Heading>
                                                    <Heading className="Title" fontSize={['24px','24px','24px','36px','36px']} color="#002EFF" lineHeight='1'>
                                                        {formatNumber(equipos.equipo_precio_oferta)}
                                                    </Heading>
                                                </Flex>
                                                <Text className="Subtitle" fontSize={['12px','12px','12px','14px','14px']}>
                                                    o {equipos.equipo_numero_cuotas} cuotas sin interés: <b>${formatNumber(equipos.equipo_valor_cuotas)}</b>
                                                </Text>
                                                <Button
                                                    w="100%" 
                                                    p="4" 
                                                    bg="#002EFF"
                                                    mt={{base: '0', md: '2'}} 
                                                    color="white" 
                                                    border='1px solid #002EFF'
                                                    mx="auto"
                                                    onClick={() => openSlide('tarjetas', equipos.equipo_descuento, `${equipos.equipo_nombre.toLowerCase()} ${equipos.equipo_referencia.toLowerCase()}`, i+1, equipos.equipo_precio_oferta, equipos.equipo_precio_normal)}
                                                    _hover={{background:"white", color:"#002EFF", border:"1px solid #002EFF"}} 
                                                    borderRadius="30" 
                                                >
                                                    Lo quiero
                                                </Button>
                                            </Box>
                                        </Flex>
                                    </SplideSlide>
                                    : <SplideSlide key={equipos.equipo_id}>
                                        <Box w={['344px','344px','344px','307px','307px']} h='100%' borderRadius='12px' border='1px solid #E9E9E9' onClick={() => openSlide('tarjetas', equipos.equipo_descuento, `${equipos.equipo_nombre} ${equipos.equipo_referencia}`, i+1, equipos.equipo_precio_oferta, equipos.equipo_precio_normal)} backgroundImage={[Movil,Movil,Movil,`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${equipos.equipo_imagen}`,`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${equipos.equipo_imagen}`]} backgroundSize="cover" backgroundPosition={['center','center','center','top','top']} backgroundRepeat="no-repeat" _hover={{border:'1px solid #002EFF'}}>
                                        </Box>
                                        {/* <Flex justifyContent='center' maxWidth='306px' h='500px' pos='relative' alignItems='center' borderRadius='12px' onClick={() => openSlide('tarjetas', equipos.equipo_descuento, `${equipos.equipo_nombre} ${equipos.equipo_referencia}`, i+1, equipos.equipo_precio_oferta, equipos.equipo_precio_normal)}>
                                            <Image _hover={{border:'1px solid #002EFF'}} borderRadius='12px' justifyContent='center' alignItems='center' display={['flex','flex','none','none','none']} src={Movil} />
                                            <Image _hover={{border:'1px solid #002EFF'}} border='1px solid #E9E9E9' objectPosition='center' objectFit='cover' borderRadius='12px' display={['none','none','block','block','block']} src={`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${equipos.equipo_imagen}`} />
                                        </Flex> */}
                                    </SplideSlide>
                            ))
                            : <>
                                <SplideSlide>
                                    <Skeleton h={['272px','272px','526px','526px','526px']} borderRadius='12px' w='306px' />
                                </SplideSlide>
                                <SplideSlide>
                                    <Skeleton h={['272px','272px','526px','526px','526px']} borderRadius='12px' w='306px' />
                                </SplideSlide>
                                <SplideSlide>
                                    <Skeleton h={['272px','272px','526px','526px','526px']} borderRadius='12px' w='306px' />
                                </SplideSlide>
                                <SplideSlide>
                                    <Skeleton h={['272px','272px','526px','526px','526px']} borderRadius='12px' w='306px' />
                                </SplideSlide>
                                <SplideSlide>
                                    <Skeleton h={['272px','272px','526px','526px','526px']} borderRadius='12px' w='306px' />
                                </SplideSlide>
                            </>
                        }
                    </SplideTrack>

                    <div className="splide__arrows">
                        <button className="splide__arrow splide__arrow--prev arrow-next" type='button' >
                            <IconArrowRight size='5px' />
                        </button>
                        <button className="splide__arrow splide__arrow--next arrow-next" type='button' aria-label="Next slide" aria-controls="splide02-track">
                            <IconArrowRight size='5px' />
                        </button>
                    </div>
                </Splide>
            </Box>

            {/* Encuentra tus marcas */}
            <Box w='90%' mx='auto' my='16'>
                <Heading className="General" fontSize={['36px','36px','46px','46px','46px']}>
                    Encuentra tus marcas favoritas
                </Heading>

                <SimpleGrid columns={3} spacing='3' mt='5'>
                    <Flex py='8px' h={['104px','104px','80px','80px','80px']} w='100%' bg='#F7F7F7' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='1'>
                        <Image src={apple} m='auto' h={['50%','50%','auto','auto','auto']} />
                    </Flex>
                    <Flex py='8px' h={['104px','104px','80px','80px','80px']} w='100%' bg='#F7F7F7' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='1'>
                        <Image src={samsung} m='auto' h={['50%','50%','auto','auto','auto']} />
                    </Flex>
                    <Flex py='8px' h={['104px','104px','80px','80px','80px']} w='100%' bg='#F7F7F7' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='1'>
                        <Image src={xiaomi} m='auto' h={['50%','50%','auto','auto','auto']} />
                    </Flex>
                </SimpleGrid>
                <SimpleGrid columns={4} spacing='3' mt='5'>
                    <Flex py='8px' h={['72px','72px','64px','64px','64px']} w='100%' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='2'>
                        <Image src={motorola} m='auto' />
                    </Flex>
                    <Flex py='8px' h={['72px','72px','64px','64px','64px']} w='100%' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='2'>
                        <Image src={honor} m='auto' />
                    </Flex>
                    <Flex py='8px' h={['72px','72px','64px','64px','64px']} w='100%' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='2'>
                        <Image src={sony} m='auto' />
                    </Flex>
                    <Flex py='8px' h={['72px','72px','64px','64px','64px']} w='100%' borderRadius='12px' m='auto' boxShadow='0px 0px 0px 1px rgba(0,0,0,0.10) inset' px='2'>
                        <Image src={harman} m='auto' />
                    </Flex>
                </SimpleGrid>
            </Box>

            {/* Pagos */}
            <Box w={['90%','90%','90%','70%','70%']} mx='auto' mt='10' mb='10'>
                <Flex flexDirection={['column','column','column','row','row']} w='100%'>
                    <SimpleGrid columns='4' alignItems='center' spacing={[1,1,1,10,10]} w={['100%','100%','100%','70%','70%']} boxShadow='0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset' py='3' px={[3,3,10,16,16]} borderRadius='12px'>
                        <Box m='auto'>
                            <IconEntelExpress sizeH='45' sizeW='80' />
                        </Box>
                        <Box textAlign='center'>
                            <Text fontSize={['sm','xs','sm','sm','sm']} className="Subtitle">
                                Retíralo en
                            </Text>
                            <Heading className="Subtitle" color='#002eff' size={['md','md','md','md','md']}>
                                1hr.
                            </Heading>
                        </Box>
                        <Box textAlign='center'>
                            <Text fontSize={['sm','xs','sm','sm','sm']} className="Subtitle">
                                Recíbelo en
                            </Text>
                            <Heading className="Subtitle" color='#002eff' size={['md','md','md','md','md']}>
                                24hr.
                            </Heading>
                        </Box>
                        <Box textAlign='center'>
                            <Text fontSize={['sm','sm','sm','sm','sm']} className="Subtitle">
                                Despacho en
                            </Text>
                            <Heading className="Subtitle" color='#002eff' size={['md','md','md','md','md']}>
                                24hrs.
                            </Heading>
                        </Box>
                    </SimpleGrid>
                    
                    <HStack boxShadow='0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset' w={['100%','100%','100%','35%','35%']} py='3' px={5} borderRadius='12px' ml={[0,0,0,5,5]} mt={[4,4,4,0,0]}>
                        <IconPagoCuotas />
                        <Box>
                            <Text fontSize='md' className="Title">Devolución gratis</Text>
                            <Text className="General" fontSize='sm'>Tienes 10 días desde que lo recibes.</Text>
                        </Box>
                    </HStack>
                </Flex>

                <Heading fontWeight='500' px={[5,5,0,0,0]} size='lg' className="General" textAlign='center' mt={[7,7,10,10,10]}>Compra tus equipos en cuotas sin interés</Heading>

                <SimpleGrid columns={[1,1,1,2,2]} spacing={[5,5,10,10,10]} mt='5'>
                    <Box>
                        <Flex boxShadow='0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset' borderRadius='12px'>
                            <Flex bg='#E9E9E9' px='4' py='2' w='50%' spacing='5' borderTopLeftRadius='12px' borderBottomLeftRadius='12px'>
                                <Box>
                                    <Text className="Subtitle" fontSize={['md','md','lg','lg','lg']}>Paga hasta en</Text>
                                    <Text className="Title" fontSize={['lg','lg','xl','xl','xl']}>12 cuotas</Text>
                                    <Text className="Subtitle" fontSize={['md','md','lg','lg','lg']}>Sin interés con</Text>
                                </Box>  
                                <Spacer />
                                <Box m='auto' h='100%' display='grid' alignContent='space-around'>
                                    <IconVisa />
                                    <IconMastercard />
                                </Box>
                            </Flex>
                            <Box m='auto'>
                                <Text className="Subtitle" color='#002eff' fontSize={'lg'}>
                                    De <b>cualquier banco</b>
                                </Text>
                                <Text className="Subtitle" color='#002eff' fontSize={'lg'}>
                                    o <b>casa comercial</b>
                                </Text>
                            </Box>
                        </Flex>
                        <Text className='Subtitle' lineHeight='1' mt='2' fontSize='sm'>
                            *Disponible solo para tarjetas de Crédito nacionales con logos Visa / MasterCard
                        </Text>
                    </Box>
                    
                    <Box h='100%' w='100%'>
                        <Box borderRadius='12px' boxShadow='0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset'>
                            <Box bg='#E9E9E9' borderTopLeftRadius='12px' borderTopRightRadius='12px' className="Subtitle" py='2' textAlign='center'>
                                Hasta <b>24 cuotas</b> sin interés con
                            </Box>
                            <HStack alignItems='center' justifyContent='center' spacing='5' m='auto' py='22.5px'>
                                <IconEntelVisa />
                                <IconBci />
                                <IconSantander />
                            </HStack>
                        </Box>
                        <HStack mt='2'>
                            <Text className="Subtitle" lineHeight='1'>
                                o en hasta <b>18 cuotas</b> sin interés con
                            </Text>
                            <IconBancoChile />
                        </HStack>
                    </Box>
                </SimpleGrid>
            </Box>

            {/* Por que elegir entel */}
            <Box backgroundImage={[EquiposDownMovil,EquiposDownMovil,EquiposDown]} backgroundSize="cover" backgroundRepeat="no-repeat" my={[0,0,10,10,10]}>
                <Box w={['90%','90%','90%','90%','90%']} m='auto' pt={[5,5,20,20,20]}>
                    <Heading fontWeight='500' className="General" size='2xl' color='white' lineHeight='1.2' pr={[5,5,0,0,0]}>
                        ¿Por qué <b>elegir Entel?</b>
                    </Heading>
                </Box>

                <Box w={['90%','90%','90%','90%','90%']} m='auto' pb={[8,8,16,16,16]} pt={[20,20,10,10,10]}>
                    <Splide
                        hasTrack={false}
                        options={{
                            type: 'loop',
                            perPage: 3,
                            perMove: 1,
                            pagination: true,
                            autoplay: false,
                            gap: '30px',
                            arrows: false,
                            breakpoints: {
                                840: {
                                    perPage: 2,
                                },
                                600: {
                                    perPage: 1,
                                }
                            },
                        }}
                    >
                        <SplideTrack>
                            <SplideSlide>
                                <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                    <IconDelivery size='48' />
                                    <Heading className="Title" size='md' mt='3'>
                                        Despacho gratis
                                    </Heading>
                                    <Text className="General" mt='2' fontSize='lg'>
                                        Puedes elegir entre: Express (2 hrs), Programado (24 hrs) o Retiro en tienda (1 hr). ¡Será gratis!
                                    </Text>
                                </Box>
                            </SplideSlide>
                            <SplideSlide>
                                <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                    <IconOferta color='#002EFF' size='48' />
                                    <Heading className="Title" size='md' mt='3'>
                                        Descuentos para clientes
                                    </Heading>
                                    <Text className="General" mt='2' fontSize='lg'>
                                        Al ser Entel tienes un mundo de beneficios.¡Puedes llevar los equipos precios especiales!
                                    </Text>
                                </Box>
                            </SplideSlide>
                            <SplideSlide>
                                <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                    <Icon5G size='48' />
                                    <Heading className="Title" size='md' mt='3'>
                                        5G de Entel
                                    </Heading>
                                    <Text className="General" mt='2' fontSize='lg'>
                                        Descubre nuestro catálogo de celulares compatibles con la red 5G de Entel.
                                    </Text>
                                </Box>
                            </SplideSlide>
                        </SplideTrack>
                    </Splide> 
                </Box>
            </Box>

            {/* Abrir modal */}
            {
                openSlideModal && 
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal 
                        setOpenSlideModal={setOpenSlideModal} 
                        priceTyc={''}
                        openSlideModal={openSlideModal} 
                        descuento={''}
                        price={''}
                        valuePhoneInitial={''}
                        plan={equipoSelected}
                        submitInitial={false}
                        view={isBanner ? 'banner' : 'equipos'}
                        id={id}
                        positionEquipo={positionEquipo}
                    />
                </Box>
            }
        </>
    )
}

export default Equipos